export const certifications = [
  /* {
    name: "AWS Data Engineer - Associate",
    img: "/images/certifications/AWS-DE.png",
    company: "Amazon Web Services (AWS)",
    released: "",
    expired: "",
    link:
      "https://aws.amazon.com/it/certification/certified-data-engineer-associate/",
    verification:docker
      "",
  }, */
  // {
  //   name: "Cisco Certified Network - Associate (CCNA)",
  //   img: "/images/certifications/ccna.png",
  //   company: "Cisco",
  //   released: "",
  //   expired: "",
  //   link:
  //     "https://www.cisco.com/c/en/us/training-events/training-certifications/certifications/associate/ccna.html",
  //   verification:
  //     "",
  // },
  {
    name: "UBS Certified Engineer - Gold",
    img: "https://images.credly.com/size/680x680/images/d7b1cf85-b412-466e-a605-7e495f0c2962/image.png",
    company: "UBS",
    released: "Dec 2025",
    expired: "",
    link:
      "https://www.credly.com/badges/de503d39-a8fa-4c0c-82aa-3c29e37b3dbe/public_url",
    verification:
      "https://www.credly.com/badges/de503d39-a8fa-4c0c-82aa-3c29e37b3dbe/public_url",
  },
  {
    name: "Microsoft Certified - Azure Data Fundamentals",
    img: "/images/certifications/dp-900.png",
    company: "Microsoft",
    released: "Aug 2024",
    expired: null,
    link:
      "https://learn.microsoft.com/en-us/credentials/certifications/azure-data-fundamentals/?practice-assessment-type=certification",
    verification:
      "https://learn.microsoft.com/api/credentials/share/en-us/DanieleBocchino-5571/1722E8978F3B41DF?sharingId=B510E3A66A0CF90B",
  },
  {
    name: "Microsoft Certified - Azure AI Fundamentals",
    img: "/images/certifications/ai-900.png",
    company: "Microsoft",
    released: "Aug 2024",
    expired: null,
    link:
      "https://learn.microsoft.com/en-us/credentials/certifications/azure-ai-fundamentals/?practice-assessment-type=certification",
    verification:
      "https://learn.microsoft.com/api/credentials/share/en-us/DanieleBocchino-5571/6845B9EFC9040143?sharingId=B510E3A66A0CF90B",
  },
  {
    name: "Microsoft Certified - Azure Fundamentals",
    img: "/images/certifications/az-900.png",
    company: "Microsoft",
    released: "Jul 2024",
    expired: null,
    link:
      "https://learn.microsoft.com/en-us/credentials/certifications/azure-fundamentals/?practice-assessment-type=certification",
    verification:
      "https://learn.microsoft.com/api/credentials/share/en-us/DanieleBocchino-5571/936C0BB6798B9272?sharingId=B510E3A66A0CF90B",
  },
  {
    name: "Terraform - Associate",
    img: "/images/certifications/terraform.png",
    company: "HashiCorp",
    released: "Oct 2023",
    expired: "Oct 2025",
    link:
      "https://www.hashicorp.com/certification/terraform-associate",
    verification:
      "https://www.credly.com/badges/725c881c-5401-4c31-a585-a4854a629952/public_url",
  },
  {
    name: "AWS Developer - Associate (DVA-C01)",
    img: "/images/certifications/AWS-DA.png",
    company: "Amazon Web Services (AWS)",
    released: "Feb 2023",
    expired: "Feb 2026",
    link:
      "https://aws.amazon.com/it/certification/certified-developer-associate/",
    verification:
      "https://www.credly.com/badges/27f7c554-3e41-45f2-b9fe-0afe597e5dcd/public_url",
  },
  {
    name: "AWS Solution Architects - Associate (SAA-C03)",
    img: "/images/certifications/AWS-SA.png",
    company: "Amazon Web Services (AWS)",
    released: "Feb 2023",
    expired: "Feb 2026",
    link:
      "https://aws.amazon.com/it/certification/certified-solutions-architect-associate/",

    verification:
      "https://www.credly.com/badges/933b497c-bc13-4f94-88e0-612088d8ab11/public_url",
  },
  {
    name: "AWS Cloud Practitioner Essentials",
    img: "/images/certifications/AWS-CP.png",
    company: "Amazon Web Services (AWS)",
    released: "Dec 2022",
    expired: "Dec 2025",
    link:
      "https://aws.amazon.com/it/certification/certified-cloud-practitioner/",
    verification:
      "https://www.credly.com/badges/7c9c4ee2-0ef2-4e53-8c5c-d205fe900e65/public_url",
  },
  {
    name: "IBM Professional Certificate in Data Science",
    img: "/images/certifications/IBM-data-science.png",
    company: "IBM",
    released: "March 2023",
    expired: null,
    link: "https://www.coursera.org/account/accomplishments/specialization/certificate/VBCBCYEA92YM",
    verification:
      "https://www.credly.com/badges/b724b6d1-dc57-43a3-b329-f5a1fb079471/public_url",
  },
  {
    name: "AWS Cloud Quest: Cloud Practitioner",
    img: "https://images.credly.com/size/680x680/images/30816e43-2550-4e1c-be22-3f03c5573bb9/blob",
    company: "AWS",
    released: "March 2023",
    expired: null,
    link: "https://aws.amazon.com/it/training/digital/aws-cloud-quest/",
    verification:
      "https://www.credly.com/badges/8c590962-04a7-4a04-9777-a513bf617788/public_url",
  },
  {
    name: "AWS Cloud Quest: Solutions Architect",
    img: "https://images.credly.com/size/680x680/images/320bfb8f-e722-41b9-a70a-c3fb07402981/blob",
    company: "AWS",
    released: "April 2023",
    expired: null,
    link: "https://aws.amazon.com/it/training/digital/aws-cloud-quest/",
    verification:
      "https://www.credly.com/badges/93259c26-48db-4df0-8cd3-21dab587f1a0/public_url",
  },
];


export const courses = [
  /* {
    name: "AWS Data Engineer - Associate",
    img: "/images/certifications/AWS-DE.png",
    company: "Amazon Web Services (AWS)",
    released: "",
    expired: "",
    link:
      "https://aws.amazon.com/it/certification/certified-data-engineer-associate/",
    verification:docker
      "",
  }, */
  {
    name: "Cisco Certified Network - Associate (CCNA)",
    img: "/images/certifications/ccna.png",
    company: "Cisco",
    released: "",
    expired: "",
    link:
      "https://www.cisco.com/c/en/us/training-events/training-certifications/certifications/associate/ccna.html",
    verification:
      "",
  },
  
  {
    name: "Terraform - Associate",
    img: "/images/certifications/terraform.png",
    company: "HashiCorp",
    released: "Oct 2023",
    expired: "Oct 2025",
    link:
      "https://www.hashicorp.com/certification/terraform-associate",
    verification:
      "https://www.credly.com/badges/725c881c-5401-4c31-a585-a4854a629952/public_url",
  },
  /* {
    name: "AWS SysOps Administrator - Associate",
    img: "/images/certifications/AWS-SOA.png",
    company: "Amazon Web Services (AWS)",
    released: "",
    expired: "",
    link:
      "https://aws.amazon.com/it/certification/certified-sysops-admin-associate/",
    verification:
      "https://www.credly.com/earner/earned/badge/27f7c554-3e41-45f2-b9fe-0afe597e5dcd",
  }, */
  {
    name: "AWS Developer - Associate (DVA-C01)",
    img: "/images/certifications/AWS-DA.png",
    company: "Amazon Web Services (AWS)",
    released: "Feb 2023",
    expired: "Feb 2026",
    link:
      "https://aws.amazon.com/it/certification/certified-developer-associate/",
    verification:
      "https://www.credly.com/badges/27f7c554-3e41-45f2-b9fe-0afe597e5dcd/public_url",
  },
  {
    name: "AWS Solution Architects - Associate (SAA-C03)",
    img: "/images/certifications/AWS-SA.png",
    company: "Amazon Web Services (AWS)",
    released: "Feb 2023",
    expired: "Feb 2026",
    link:
      "https://aws.amazon.com/it/certification/certified-solutions-architect-associate/",

    verification:
      "https://www.credly.com/badges/933b497c-bc13-4f94-88e0-612088d8ab11/public_url",
  },
  {
    name: "AWS Cloud Practitioner Essentials",
    img: "/images/certifications/AWS-CP.png",
    company: "Amazon Web Services (AWS)",
    released: "Dec 2022",
    expired: "Dec 2025",
    link:
      "https://aws.amazon.com/it/certification/certified-cloud-practitioner/",
    verification:
      "https://www.credly.com/badges/7c9c4ee2-0ef2-4e53-8c5c-d205fe900e65/public_url",
  },
  {
    name: "IBM Professional Certificate in Data Science",
    img: "/images/certifications/IBM-data-science.png",
    company: "IBM",
    released: "March 2023",
    expired: null,
    link: "https://www.coursera.org/account/accomplishments/specialization/certificate/VBCBCYEA92YM",
    verification:
      "https://www.credly.com/badges/b724b6d1-dc57-43a3-b329-f5a1fb079471/public_url",
  },
  {
    name: "AWS Cloud Quest: Cloud Practitioner",
    img: "https://images.credly.com/size/340x340/images/2784d0d8-327c-406f-971e-9f0e15097003/image.png",
    company: "AWS",
    released: "March 2023",
    expired: null,
    link: "https://aws.amazon.com/it/training/digital/aws-cloud-quest/",
    verification:
      "https://www.credly.com/badges/8c590962-04a7-4a04-9777-a513bf617788/public_url",
  },
  {
    name: "AWS Cloud Quest: Solutions Architect",
    img: "https://images.credly.com/size/340x340/images/9e9e7ef7-384f-4636-8743-1b89a68fb46b/image.png",
    company: "AWS",
    released: "April 2023",
    expired: null,
    link: "https://aws.amazon.com/it/training/digital/aws-cloud-quest/",
    verification:
      "https://www.credly.com/badges/93259c26-48db-4df0-8cd3-21dab587f1a0/public_url",
  },
];
